'use client';
import { useTranslation } from '@/i18n/client';
import { useStores } from '@/models';
import { buildSearchUrl } from '../../util';
import { useRouter, useSearchParams } from 'next/navigation';
import styles from './index.module.scss';
import CDNImage from '@/components/cdnImage/cdnImage';
import { SearchTileInfoVO } from '@/apis/s/s.interface';

interface CategoryProps {
  logid: string;
  onSearch?: () => void;
  baseUrl?: string;
  searchTileInfo: SearchTileInfoVO;
}

interface CategoryItem {
  order: number;
  categoryName: string;
  pictureUrl: string;
}

const Category = ({ logid, onSearch, baseUrl, searchTileInfo }: CategoryProps) => {
  const { t } = useTranslation();
  const { searchStore } = useStores();
  const searchParams = useSearchParams();
  const router = useRouter();
  console.log(searchTileInfo, 'searchTileInfosearchTileInfo');

  // 处理分类项点击事件
  const handleToggleCategoryItem = (item: CategoryItem) => {
    // 将当前分类名称拼接到搜索关键词中
    const currentKeywords = searchStore.keywords || '';
    const newKeywords = currentKeywords
      ? `${currentKeywords},${item.categoryName}`
      : item.categoryName;
    searchStore.setKeywords(newKeywords);

    // 设置页面为第一页
    searchStore.setPage(1);

    // 获取更新后的搜索参数，确保包含新的关键词
    const params = searchStore.searchParamsWithExtra({
      page: 1,
    });

    // 更新浏览器历史记录，确保 URL 包含更新后的关键词
    window.history.pushState(null, '', buildSearchUrl(params, baseUrl));
    router.push(buildSearchUrl(params, baseUrl));

    // 触发搜索
    onSearch && onSearch();
  };

  return (
    <div className={styles.categoryContainer}>
      <div className={styles.container}>
        {searchTileInfo?.searchTileList.map((item: CategoryItem) => (
          <div
            key={item.order}
            className={styles.categoryImg}
            onClick={() => handleToggleCategoryItem(item)}
            style={{ cursor: 'pointer' }}
          >
            <div className={styles.imgContainer}>
              <CDNImage src={item.pictureUrl} width={48} height={48} alt={item.categoryName} />
            </div>

            <p>{item.categoryName}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Category;
